import angular from 'angular';

import {
  ssDialogService, loaderService, orgDataService, emDataService, userService
} from 'app/services';
import copy from 'app/constants';
import { alerts } from 'app/components/global';

import beginServiceTrialDialog from './beginServiceDialog';
import caEditCustomer from './editCustomer';

import customerAdministrationDirective from './customer-administration.directive';
import CustomerAdministrationDirectiveController from './customer-administration.directive.controller';

import nameMessages from './displayName.messages.html';
import emailMaskMessages from './emailMask.messages.html';
import emailSuffixMessages from './emailSuffix.messages.html';


// 'jquery.ui',
// require('');

// 'jquery.validate',
// 'jquery.ui.widget',
// 'jquery.iframe',
// 'jquery.fileupload',


export default angular.module('app.components.admin.customerAdministration', [
  copy,
  loaderService,
  alerts,
  orgDataService,

  ssDialogService,
  emDataService,
  userService,

  beginServiceTrialDialog,
  caEditCustomer
])
  .directive('customerAdministrationDirective', customerAdministrationDirective)
  .controller('CustomerAdministrationDirectiveController', CustomerAdministrationDirectiveController)
  .run(($templateCache) => {
    $templateCache.put('displayName.messages.html', nameMessages);
    $templateCache.put('emailMask.messages.html', emailMaskMessages);
    $templateCache.put('emailSuffix.messages.html', emailSuffixMessages);
  })
  .name;


export const customerAdminRouteConfig = {
  template: require('./customer-administration.directive.html'),
  controller: 'CustomerAdministrationDirectiveController',
  controllerAs: 'customerAdminVM'
};
console.log('app.components.admin.customerAdministration created');
